export default __webpack_public_path__ + "static/media/answerCorrect.af5a3b5b.mp3";